import React from 'react';
import { Scale, Clock, Search, Lock } from 'lucide-react';
const pillars = [{
  icon: Scale,
  title: 'Independence',
  description: 'All experts provide impartial, CPR Part 35 compliant evidence. Our governance ensures objectivity regardless of instructing party.',
  iconAlt: 'Scales icon representing impartial and independent expert evidence'
}, {
  icon: Clock,
  title: 'Triage',
  description: 'Every case is reviewed by our clinical lead to ensure the correct specialist is assigned within 24 hours.',
  iconAlt: 'Clock icon representing rapid 24-hour clinical triage process'
}, {
  icon: Search,
  title: 'Scrutiny',
  description: 'Reports are audited for clarity, nomenclature accuracy, and adherence to legal instructions before release.',
  iconAlt: 'Search icon representing rigorous quality scrutiny of medico-legal reports'
}, {
  icon: Lock,
  title: 'Security',
  description: 'GDPR-compliant, encrypted data handling for all medical records and legal files. ISO 27001 certified.',
  iconAlt: 'Lock icon representing GDPR-compliant encrypted data security'
}];
export function WhyChooseUs() {
  return <section className="py-10 bg-warm-100" aria-label="Clinical governance and quality assurance framework" data-id="element-467">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-468">
        <div className="text-center max-w-2xl mx-auto mb-8" data-id="element-469">
          <h2 className="text-3xl md:text-4xl font-bold text-ink-900 tracking-tight mb-4" data-id="element-470">
            Clinical Governance & Quality Assurance
          </h2>
          <p className="text-lg text-ink-500 leading-relaxed" data-id="element-471">
            Our framework ensures every report meets the highest standards of
            clinical accuracy and legal compliance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-8" data-id="element-472">
          {pillars.map(pillar => <div key={pillar.title} className="bg-white rounded-2xl border border-warm-200 p-8 flex items-start gap-5" data-id="element-473">
              <div className="w-12 h-12 bg-warm-50 rounded-xl flex items-center justify-center flex-shrink-0 border border-warm-200" role="img" aria-label={pillar.iconAlt} data-id="element-474">
                <pillar.icon className="h-6 w-6 text-slate-600" aria-hidden="true" data-id="element-475" />
              </div>
              <div data-id="element-476">
                <h3 className="text-lg font-bold text-ink-900 mb-2" data-id="element-477">
                  {pillar.title}
                </h3>
                <p className="text-ink-500 leading-relaxed text-[15px]" data-id="element-478">
                  {pillar.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* Why Instruct quote */}
        <div className="bg-white rounded-2xl border border-warm-200 p-8 md:p-10 text-center max-w-3xl mx-auto" data-id="element-479">
          <h3 className="text-xl md:text-2xl font-bold text-ink-900 mb-4" data-id="element-480">
            Why Instruct UK Medico-Legal Assessments?
          </h3>
          <blockquote className="text-lg text-ink-600 leading-relaxed italic" data-id="element-481">
            "We bridge the gap between clinical complexity and legal clarity. By
            managing the administrative and clinical governance, we allow
            experts to focus on the evidence and solicitors to focus on the
            case."
          </blockquote>
        </div>
      </div>
    </section>;
}